export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-25-548cec0e93be6dd4fc3634b420580ddc.png";